import apiClient from '../../api/apiClient';

export const editProfileApi = async (profileData) => {
  const response = await apiClient.patch('/partners/itsales-partner/profile/edit', profileData);
  return response.data;
};

export const changePasswordApi = async (passwordData) => {
  const response = await apiClient.patch('partners/itsales-partner/password-change', passwordData);
  return response.data;
};

export const verifyEmailApi = async (emailData) => {
  const response = await apiClient.post('/partners/itsales-partners/verify-mail', emailData);
  return response.data;
};

export const verifyTokenApi = async (token, email) => {
  const response = await apiClient.get(`/partners/itsales-partner/verify-token/${token}/${email}`);
  return response.data;
};

// get Profile
export const getProfileApi = async (id) => {
  const response = await apiClient.get(`/partners/itsales-partner/${id}/profile`);
  return response.data.data;
};

export const sendEmailApi = async (emailData) => {
  const response = await apiClient.post('/partners/oem-partners/send-email', emailData);
  return response.data;
};